howspace.components.filterPicker = (() => {
    'use strict';

    const handleInputChanged = e => {
        const filterPicker = $(e.currentTarget).closest('.howspace-filter-picker');

        let userProfileFields = [];
        let users = [];
        let userLists = [];
        let teams = [];

        filterPicker.find('input:checked').each(function() {
            const input = $(this);
            const type = input.data('filter-type');
            switch (type) {
                case 'user-profile-field':
                    const item = input.val();
                    const userProfileField = [item.substring(0, item.indexOf('_')), item.substring(item.indexOf('_') + 1)];
                    userProfileFields.push({
                        user_profile_field_id: userProfileField[0],
                        value: userProfileField[1]
                    });
                    break;

                case 'user':
                    users.push(input.val());
                    break;

                case 'userlist':
                    userLists.push(input.val());
                    break;

                case 'team':
                    teams.push(input.val());
                    break;
            }
        });

        let filter = {};
        if (userProfileFields.length > 0) {
            filter['limit_results_to_user_profile_field'] = userProfileFields;
        }
        if (users.length > 0) {
            filter['limit_results_to_user'] = users.join(',');
        }
        if (userLists.length > 0) {
            filter['limit_results_to_userlist'] = userLists.join(',');
        }
        if (teams.length > 0) {
            filter['limit_results_to_team'] = teams.join(',');
        }
        if (Object.keys(filter).length === 0) {
            filter = null;
        }

        filterPicker.find('input[type="hidden"]').val(JSON.stringify(filter));

        const input = $(e.currentTarget);
        const filtersWrapper = filterPicker.find('.filters');
        const filterPill = filtersWrapper.find(`.howspace-filter[data-type="${input.data('filter-type')}"][data-value="${input.val()}"]`);
        filterPill.toggleClass('d-none');
    };

    return {
        init: elem => {
            elem.findIncludingSelf('.howspace-filter-picker:not(.howspace-filter-picker-initialized)').each(function () {
                const filterPicker = $(this);
                filterPicker.addClass('howspace-filter-picker-initialized');

                filterPicker.on('change', 'input', handleInputChanged);
            });
        },
        destroy: elem => {
            elem.findIncludingSelf('.howspace-filter-picker.howspace-filter-picker-initialized').each(function () {
                const filterPicker = $(this);
                filterPicker.removeClass('howspace-filter-picker-initialized');
            });
        }
    }
})();
